import { SingleServiceCenterDto } from "api"
import RatioElement from "common/ElementRatio"
import { useIsDesktop } from "common/MediaQueries"
import { useState } from "react"
import styled from "styled-components"
import { Swiper, SwiperSlide } from "swiper/react"
import { TypographyRtl } from "theme/shared"
import ServiceCenterGalleryDialog from "./ServiceCenterGalleryDialog"

const StyledWrapper = styled.div`
  width: 100%;
  margin-top: 40px;
`
const StyledSwiper = styled(Swiper)`
  width: 100%;
  cursor: pointer;
`
const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 3px;
  border: 1px solid ${(p) => p.theme.colors.black};
`
const StyledRatioElement = styled(RatioElement)`
  margin: 4px 0;
`

type CenterGalleryProps = {
  serviceCenter: SingleServiceCenterDto
}

const CenterGallery = ({ serviceCenter }: CenterGalleryProps) => {
  const isDesktop = useIsDesktop()
  const [active, setActive] = useState<number | null>(null)

  if (!serviceCenter?.images?.length && !serviceCenter?.videoUrl?.length)
    return null

  return (
    <StyledWrapper>
      <TypographyRtl $mb="20px" variant="h3">
        תמונות ממרכז השירות
      </TypographyRtl>
      <StyledSwiper
        spaceBetween={8}
        slidesPerView={isDesktop ? 9.2 : 3.2}
        slidesOffsetBefore={2}
        onClick={(swiper) => {
          setActive(swiper.clickedIndex)
        }}
      >
        {serviceCenter.images.map((item, i) => (
          <SwiperSlide
            tabIndex={0}
            role="button"
            key={i}
            style={{ marginBottom: 4 }}
            aria-label="תמונת גלריה לחץ להגדלה"
          >
            <StyledRatioElement ratio={3 / 2} css>
              <StyledImage
                src={`${item.imageUrl}?width=${Math.floor(375 / 3)}`}
                alt={item.alt}
                role="presentation"
                aria-hidden={true}
              />
            </StyledRatioElement>
          </SwiperSlide>
        ))}
        {serviceCenter.videoUrl.map((item, i) => (
          <SwiperSlide key={i}>
            <StyledRatioElement ratio={3 / 2} css>
              <StyledImage
                src={`${
                  serviceCenter.videoThumbnailUrl[i]?.imageUrl
                }?width=${Math.floor(375 / 3)}`}
                alt={serviceCenter.videoThumbnailUrl[i]?.alt}
              />
              {/* <Styled.PlayIcon /> */}
            </StyledRatioElement>
          </SwiperSlide>
        ))}
      </StyledSwiper>
      <ServiceCenterGalleryDialog
        active={active}
        images={serviceCenter.images}
        videos={serviceCenter.videoUrl}
        onClose={() => {
          setActive(null)
        }}
      />
    </StyledWrapper>
  )
}

export default CenterGallery
